import React from "react";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryCustomerEntity } from "../../../query/onboarding/queries/useQueryCustomerEntity";
import { useMemberProfile } from "../../../query/users/queries";
import { Form } from "./Form";
import { useMutationSubmit } from "./useMutationSubmit";

type Props = {
  onSuccess?: () => void;
  onBack?: () => void;
  withPanel?: boolean;
  skipPayoutSettingsUpdate?: boolean;
};

export const FormManuallyAddInternationalAccount: React.FC<Props> = ({
  onSuccess,
  onBack,
  withPanel,
  skipPayoutSettingsUpdate
}) => {
  const userId = useUserId();
  const queryCustomerEntity = useQueryCustomerEntity();
  const queryMemberProfile = useMemberProfile(userId);
  const [submit, submitMeta] = useMutationSubmit(
    { skipPayoutSettingsUpdate },
    {
      onSuccess
    }
  );

  if (!queryCustomerEntity.isFetched || !queryMemberProfile.isFetched) {
    return null;
  }

  const country =
    queryCustomerEntity.data?.country ||
    queryMemberProfile.data?.profile.address?.country;

  return (
    <Form
      onSubmit={data => {
        submit({ data });
      }}
      error={submitMeta.error}
      isLoading={submitMeta.isLoading}
      defaultValues={{
        country: country
      }}
      onBack={onBack}
      withPanel={withPanel}
    />
  );
};
